import { DefaultSelection36RfiReopenPayload, IPRFIItem, IRFIReopenApprovalStep } from "../api-generated";
import RFIReopenApprovalDetail from "./rfiReopenApprovalDetail";
import RFIUpdateBase from "./rfiUpdateBase";

export default class RFIReopenApproval
  extends RFIUpdateBase
  implements IRFIReopenApprovalStep
{
  public rfi_reopen: RFIReopenApprovalDetail;

  constructor(contractId: string, sub: IPRFIItem, reopen:DefaultSelection36RfiReopenPayload) {
    super(contractId, sub);
    this.rfi_reopen = new RFIReopenApprovalDetail(reopen);
  }
}
